import { Form } from "react-bootstrap"
import { useFormContext } from 'react-hook-form';
import CheckboxInput from "./CheckboxInput";
import { resolvePath } from "../utils";
import FieldContext, { useFieldContext } from "./FieldContext";

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {boolean} props.heading
 * @param {string} props.id
 * @param {boolean} props.row
 * @param {boolean} props.wrap
 * @param {boolean} props.center
 * @param {number} props.maxWidth
 * @param {number} props.gap
 * @param {string} props.className
 * @param {React.CSSProperties} props.style
 */
export default function FormSection({ title, heading, id, row, wrap, center, maxWidth, gap = 0, className = "", style, children, ...rest }) {
    const { idPrefix } = useFieldContext();

    const { watch, formState: { errors } } = useFormContext();
    const error = id && resolvePath(errors, idPrefix + id);

    return <>
        {error && <Form.Control.Feedback type="invalid" className="d-block">{error.message}</Form.Control.Feedback>}
        {title && <div className="d-flex">
            <Form.Label className={`-mb-2.5 mt-1 ${heading ? "fw-bold fs-5" : ""}`}>{title}</Form.Label>
            {id && <CheckboxInput {...rest} id={id} className="ms-2 my-auto" />}
        </div>}
        <div className={"form-section " + (row ? "d-flex " : "") + (wrap ? "flex-wrap " : "") + (center ? "mx-auto justify-content-center " : "") + className} style={{ maxWidth: `${maxWidth}rem`, gap: `${gap}rem`, ...style }}>
            <FieldContext disabled={id && !watch(idPrefix + id)}>
                {children}
            </FieldContext>
        </div>
    </>;
}